export enum PARActType {
  CommunityGeneralPlan = 1,
  DevelopmentPlan = 2,
  SmallArchitectureResolution = 3,
}
